<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <bread-crumb :buttonColor="'#00B4B0'" :activeText="$t('nav.news')"></bread-crumb>
                <v-spacer></v-spacer>
                <div class="sub-header">{{ $t("news.entry-headline") }}</div>
            </div>
        </template>
        
        <template #content>
            <div class="content-wrapper">
                <v-card rounded="xl" elevation="9">
                    <div class="news-wrapper" :class="{'scroll': news.length > 3}" v-if="news !== undefined && news.length !== 0">
                        <div v-for="(newsEntry, index) in news" :key="newsEntry.id">
                            <news-list-entry-view  :news="newsEntry" :index="index" :length="news.length"></news-list-entry-view>
                            <v-divider class="middle-divider" v-if="index !== (news.length -1)"></v-divider>
                        </div>
                    </div>
                    <div class="news-wrapper" v-else>
                        <v-row class="menu-entry-empty-text empty-news d-flex justify-center align-center">{{ $t("news.entry-empty") }}</v-row>
                    </div>
                </v-card>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">
.content-wrapper {
    display: grid;
    grid-template-rows: auto;
    height: 100%;
}
.empty-news {
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
}
.change-day-button{
    height: 6vh !important;
    width: 4.5vw !important;
    border-radius: 1.2vh !important;
    margin: 0 3vw;
}
.change-day-icon{
    font-size: 8vh !important;
    color: $font-color !important;
}
.news-wrapper{
    height: 58vh;
    margin-top: 3vh;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 3vh 3vw;
}
.scroll{
    overflow: auto;
}
::-webkit-scrollbar {
    width:  10px;
    height: 10px;
}
::-webkit-scrollbar-track {
    background: transparent;
}
::-webkit-scrollbar-thumb {
    background: $font-color;
    border-radius: 5px;
}
.news-entry-header-wrapper{
    height: 9vh;
}
.news-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.news-entry-empty-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.hide {
    opacity: 0;
}
</style>
<script>
export default {
    created() {
        this.$store.dispatch({
            type: 'moduleNews/fetchNews',
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    computed: {
        news() {
            return this.$store.getters['moduleNews/tabletNews'];
        },
    }
}
</script>
